const API_PROD_URL = 'https://api1.sl-concept.pl/';
export const API_DEV_URL = 'http://localhost:8022/';
export const API_URL = process.env.REACT_APP_API_URL || API_PROD_URL;
export const RECAPTCHA_KEY = '6LfkXMcrAAAAADfOeKH3IC60puZeTiudA05yqZHc';
